import * as React from "react";
import { observer } from "mobx-react";
import { Button, message } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { ButtonsRow } from "Components/Form/ButtonsRow";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormatData } from "utils/FormatData";
import { dayjs } from "Config/dayjs";
import { ColumnProps } from "antd/lib/table";
import { API_URL } from "General/APIEndpoints";
import { API } from "General/API";
import { projectsDataStore } from "Stores/ProjectsStore";
import { SearchFilesForm } from "./SearchFilesForm";
import { stringSort, numberSort } from "utils/defaultSort";
import { contactsStore } from "Stores/ContactsStore";
import { Table } from "Components/General/Table";

class SearchResultsColumn extends React.Component<ColumnProps<API_SearchResult>> {}

interface SearchFilesProps extends WithTranslation {
  onChange?: (v: Array<API_FileDataEntity>) => void;
  onClose?: () => void;
  onTitleChange: (arg: string) => void;
  handleAddAttachments: (c: Array<API_FileDataEntity>) => void;
  step: number;
  initialValue?: API_FileDataEntity[];
}

interface SearchFilesState {
  selectedRowKeys: number[];
  loading: boolean;
  searchResults: API_SearchResult[];
  showSearchForm: boolean;
}

export const SearchFiles = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<SearchFilesProps, SearchFilesState> {
      private selectedFiles: Map<number, API_FileDataEntity>;

      constructor(props: SearchFilesProps) {
        super(props);
        this.state = {
          selectedRowKeys: [],
          loading: false,
          searchResults: [],
          showSearchForm: true,
        };
        this.selectedFiles = new Map();
      }

      componentDidMount() {
        (async () => {
          if (contactsStore.state === "RAW") {
            await contactsStore.fetch();
          }
        })();
        if (this.props.initialValue) {
          this.setInitialData();
        }
      }

      setInitialData = () => {
        const checkedFiles = [];
        this.props.initialValue.forEach((file) => {
          checkedFiles.push(file.id);
          this.selectedFiles.set(file.id, file);
        });
        this.setState({ selectedRowKeys: checkedFiles });
      };

      handleSearch = async (postObject: API_DocSearchReq) => {
        try {
          this.setState({ loading: true });
          const response: API_SearchResult[] = await API.newData(
            API_URL.SEARCH.getSearchResults(projectsDataStore.projectId),
            postObject
          );

          this.setState({ searchResults: response, showSearchForm: false });
          this.props.onTitleChange("Results");
        } catch (err) {
          throw err;
        } finally {
          this.setState({ loading: false });
        }
      };

      handleAddAttachments = () => {
        // let { selectedRowKeys, searchResults } = this.state;
        // if (!selectedRowKeys.length) {
        //   message.error(this.props.t('No files were selected.'));
        // } else {
        //   selectedRowKeys.forEach((selectedId) => {
        //     const { name, id, size } = searchResults.find(item => item.id === selectedId);
        //     console.table({ name, id, size });
        //   });
        // }

        const { selectedRowKeys } = this.state;
        if (!selectedRowKeys.length) {
          message.error(this.props.t("No files were selected"));
        } else {
          this.props.handleAddAttachments(Array.from(this.selectedFiles.values()));
        }
      };

      onSelectChange = (selectedRowKeys: number[], selectedRows) => {
        selectedRows.forEach((key) => {
          selectedRowKeys.length > this.state.selectedRowKeys.length
            ? this.state.searchResults.forEach((item) => {
                if (key.type !== "FOLDER" && item.id === key.id) {
                  this.selectedFiles.set(item.id, item);
                }
              })
            : (() => {
                const excess = this.state.selectedRowKeys.filter((element) => selectedRowKeys.indexOf(element) === -1);
                this.state.searchResults.forEach((item) => {
                  if (excess[0] === item.id) {
                    this.selectedFiles.delete(item.id);
                  }
                });
              })();
        });
        this.setState({ selectedRowKeys });
      };

      render() {
        const { showSearchForm, selectedRowKeys, searchResults, loading } = this.state;
        if (showSearchForm) {
          return <SearchFilesForm loading={loading} onSubmit={this.handleSearch} />;
        }

        return (
          <>
            <div className="mb-2 files-table" style={{ fontSize: "12px" }}>
              <Table
                name="addFilesSearch"
                dataSource={searchResults}
                rowKey="id"
                loading={loading}
                rowClassName={() => "files-row"}
                rowSelection={{
                  selectedRowKeys: selectedRowKeys,
                  onChange: this.onSelectChange,
                }}
              >
                <SearchResultsColumn
                  dataIndex={"id"}
                  width={40}
                  render={() => {
                    return <FontAwesomeIcon icon={["far", "file"]} size="lg" fixedWidth={true} />;
                  }}
                />
                <SearchResultsColumn
                  title={"Filename"}
                  dataIndex={"name"}
                  sorter={(a, b) => stringSort(a, b, "name")}
                />
                <SearchResultsColumn
                  title={"Size"}
                  dataIndex={"size"}
                  render={(text) => FormatData.formatBytes(text, 1)}
                  sorter={(a, b) => numberSort(a.size, b.size)}
                />
                <SearchResultsColumn
                  title={"Last modified"}
                  dataIndex={"created"}
                  render={(text) => dayjs(+text).format("lll")}
                  sorter={(a, b) => numberSort(a.created, b.created)}
                />
              </Table>
            </div>
            <ButtonsRow justify="end">
              <Button onClick={this.handleAddAttachments} type="primary">
                Add files
              </Button>
            </ButtonsRow>
          </>
        );
      }
    }
  )
);
